export default __webpack_public_path__ + "static/media/header-image.efedc3dd.png";